import React from "react";
import styled from "styled-components";
import { components } from "react-select";

// react-select mounts every option in the open menu and restyles the lot each time the highlighted
// one changes, so a few hundred properties make the hover crawl. The menu renders the first rows and
// says how many it is holding back; typing in the field narrows the list to what the reader wants.
const MAX_ROWS = 50;

const Held = styled.div`
    padding: 8px 12px;
    font-size: 0.75rem;
    color: #64748b;
`;

export const cappedMenuList = props => {
    const groups = React.Children.toArray(props.children);
    const shown = [];
    let room = MAX_ROWS;
    let held = 0;

    groups.forEach(group => {
        const rows = React.Children.toArray(group.props?.children);
        if (rows.length === 0) return shown.push(group);
        if (room > 0) shown.push(React.cloneElement(group, {}, rows.slice(0, room)));
        held += Math.max(0, rows.length - Math.max(room, 0));
        room -= rows.length;
    });

    return (
        <components.MenuList {...props}>
            {shown}
            {held > 0 && <Held>{held.toLocaleString()} more — type to narrow the list</Held>}
        </components.MenuList>
    );
};
